import { RoleType, MembershipLevel, MembershipProductType } from '@ace-clublabs/common-membership-api-types';
import { StatelessConfirmationCard, StatelessConfirmationItemDetails } from './StatelessConfirmationCard';
import { formatFullName, getMembershipTitle } from '../../../utils/helpers';
import { Box } from '@ace-clublabs/shared-component-library';
import { NewJoinConfirmationData } from '@lib/types';
import { formatMembershipNumber } from '../../../utils/stringHelper';
import { getDate7DaysLaterFormatted } from '../../../utils/helpers';

export const StatelessConfirmationSummary = (confirmation: NewJoinConfirmationData) => {
  const { firstName, lastName, membershipLevel, effectiveDate, expirationDate, members, membershipNumber, options } =
    confirmation;

  const hasRV = options?.some((product) => product === MembershipProductType.RV);
  const hasERS = options?.some((product) => product === MembershipProductType.ERS);
  const benefitLevelTitle = getMembershipTitle(membershipLevel as MembershipLevel, !!hasRV);

  const associateMembers = members?.filter((member) => member.roleType !== RoleType.PRIMARY);

  const allAssociateMemberNames = associateMembers
    ?.map(({ firstName, lastName }) => formatFullName(firstName, lastName))
    .join(', ');

  const primaryMemberName = formatFullName(firstName, lastName);

  const getConfirmationSummaryItems = () => {
    const summaryItems: StatelessConfirmationItemDetails[] = [
      {
        title: 'Benefit Level:',
        details: <>{benefitLevelTitle} member</>,
        showDate: true,
        dateTitle: `Effective date:`,
        effectiveDate: effectiveDate,
        className: 'benefit-level',
      },
      {
        title: 'Membership number:',
        details: <>{formatMembershipNumber(membershipNumber)}</>,
        showDate: true,
        dateTitle: `Expiration date:`,
        effectiveDate: expirationDate,
        className: 'membership-number',
      },
      {
        title: 'Primary member:',
        details: primaryMemberName,
        className: 'primary-member',
        mask: true,
      },
    ];

    if (associateMembers && associateMembers?.length > 0) {
      summaryItems.push({
        title: 'Family members:',
        details: allAssociateMemberNames,
        className: 'family-members',
        mask: true,
      });
    }

    if (hasRV || hasERS) {
      summaryItems.push({
        title: 'Add-ons:',
        details: (
          <>
            {hasRV && (
              <>
                <span style={{ display: 'block' }}>Roadside for RV/motorcycle</span>
                <span style={{ display: 'block', color: '#7527B9', fontSize: '0.875rem', fontWeight: 400 }}>
                  {`Effective on ${getDate7DaysLaterFormatted()}`}
                </span>
              </>
            )}
            {hasERS && <span style={{ display: 'block' }}>Immediate Roadside (one-time)</span>}
          </>
        ),
        className: 'add-ons',
      });
    }

    return summaryItems;
  };

  return (
    <Box className="confirmation-summary-container">
      <StatelessConfirmationCard cardTitle="Summary" items={getConfirmationSummaryItems()} />
    </Box>
  );
};
